<template>
    <div>
        <company-route-tabs
            v-if="isSuperAdmin"
            :company-id="companyId"
        ></company-route-tabs>
        <company-delivery-override-form
            :company-id="companyId"
            :entity-id="allowanceId"
        ></company-delivery-override-form>
    </div>
</template>

<script>
import CompanyDeliveryOverrideForm from '@/components/pages/companyDeliveryOverride/Form'
import CompanyRouteTabs from '@/components/pages/companies/RouteTabs'
import dirtyForm from '@/components/mixins/dirtyForm'
import AuthMixin from '@/components/mixins/AuthMixin'

export default {
    components: { CompanyDeliveryOverrideForm, CompanyRouteTabs },

    mixins: [dirtyForm, AuthMixin],

    props: {
        allowanceId: {
            type: [String, Number],
            default: null,
        },
        companyId: {
            type: [String, Number],
            default: null,
        },
    },
}
</script>
